import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const AreaChartBase = ({
  data,
  xKey,
  areas = [],
  height = 300,
  yLabel,
  showVerticalGrid = true,
  stacked = false,
  showLegend = true,
  singleArea = false,
}) => {
  const chartAreas = singleArea && areas.length ? [areas[0]] : areas;

  const isDark = document.documentElement.classList.contains("dark");

  const tickColor = isDark ? "#cbd5f5" : "#64748b";
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 5, right: 12, left: 12, bottom: 5 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="var(--chart-grid)"
            vertical={showVerticalGrid}
          />

          <XAxis
            dataKey={xKey}
            tick={{ fill: "var(--chart-tick)", fontSize: 11 }}
            axisLine={{ stroke: "var(--chart-axis)" }}
            tickLine={{ stroke: "var(--chart-axis)" }}
          />

          <YAxis
            type="number"
            domain={[0, 12]}
            ticks={[0, 3, 6, 9, 12]}
            tick={{ fill: "var(--chart-tick)", fontSize: 11 }}
            axisLine={{ stroke: "var(--chart-axis)" }}
            tickLine={{ stroke: "var(--chart-axis)" }}
            padding={{ top: 0, bottom: 0 }}
            scale="linear"
            label={
              yLabel
                ? {
                    value: yLabel,
                    angle: -90,
                    position: "insideLeft",
                    offset: 5,
                    fill: "var(--chart-tick)",
                    fontSize: 11,
                  }
                : undefined
            }
          />


          <Tooltip
            cursor={{ fill: isDark ? "#1e293b" : "#f1f5f9" }}
            contentStyle={{
              borderRadius: 8,
              border: isDark ? "1px solid #334155" : "1px solid #e2e8f0",
              fontSize: 12,
              backgroundColor: isDark ? "#0f172a" : "#ffffff",
              color: isDark ? "#e2e8f0" : "#0f172a",
            }}
          />

          {showLegend && (
            <Legend
              verticalAlign="bottom"
              height={36}
              wrapperStyle={{
                fontSize: 14,
                color: tickColor,
              }}
              iconType="circle"
              iconSize={16}
            />
          )}

          {chartAreas.map(({ key, color, label }) => (
            <Area
              key={key}
              type="monotone"
              dataKey={key}
              name={label || key}
              stroke={color}
              fill={color}
              fillOpacity={0.6}
              strokeWidth={1}
              dot={false}
              activeDot={false}
              stackId={stacked ? "stacked" : undefined}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AreaChartBase;